/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var ShareFeedbackIcon = createIcon("ShareFeedbackIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#171717';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "160",
    height: "160",
    viewBox: "0 0 160 160",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("circle", {
    cx: "80",
    cy: "80",
    r: "80",
    fill: _color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 98H78l-16 12V98h-8a4 4 0 01-4-4V54a4 4 0 014-4h52a3.998 3.998 0 014 4v40a3.997 3.997 0 01-4 4Z",
    stroke: "#fff",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 73a1 1 0 100 2 1 1 0 000-2Zm12 0a1 1 0 100 2 1 1 0 000-2Zm12 0a1 1 0 100 2 1 1 0 000-2Z",
    stroke: "#fff",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, {
  "replaceColor": true
});